module.exports = __webpack_public_path__ + "img/Orders.b6f0ffe3.jpg";